import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../components/tables/tableContext/TableContext";
import { ActivePackagesDataInterface } from "../../../../../redux/interfaces/expedition.interface";
import { getDateAndTime } from "../../../../../utils/dateAndTime";

export const activePackagesTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Nr. expeditie",
    value: "doc_trans",
    minW: 125,
  },
  {
    label: "Client",
    value: "client",
    minW: 125,
  },
  {
    label: "Pct. preluare",
    value: "pctpreluare",
    minW: 125,
  },
  {
    label: "Pct. livrare",
    value: "pctlivrare",
    minW: 125,
  },
  {
    label: "Adresa",
    value: "adresa",
    minW: 125,
  },
  {
    label: "Nod-Destinatie",
    value: "nodDestinatie",
    minW: 125,
  },
  {
    label: "Status",
    value: "status",
    minW: 125,
  },
  {
    label: "Tip colet",
    value: "tip_colet",
    minW: 125,
  },
  {
    label: "Data crearii",
    value: "data_crearii",
    minW: 125,
  },
];

export const getActivePackagesTableData = (
  data: ActivePackagesDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_doctrans_detl,
      crudData: item,
      data: [
        {
          title: item.doc_trans,
        },
        {
          title: item.client,
        },
        {
          title: item.pctpreluare,
        },
        {
          title: item.pctlivrare,
        },
        {
          title: item.adresa,
        },
        {
          title: item.nodDestinatie,
        },
        {
          badges: [
            {
              badgeText: item.denumireStatus ?? "-",
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.tip_colet ?? "-",
              badgeColor: "primary",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.data_crearii
                ? getDateAndTime(item.data_crearii)
                : "-",
              badgeColor: "light-info",
            },
          ],
        },
      ],
    };
  });
